import {forwardRef} from "react";
import {mobileImage} from "../mobileAssets";

const CharacterListScreen = forwardRef(function CharacterListScreen({characters, onOpenCharacter}, ref) {
    return (
        <div ref={ref} className="page_two mobile-section-page">
            <p className="mobile-quality-note">*游戏研发中，非最终品质。</p>
            {characters.map(function (item, index) {
                return (
                    <button className="item" type="button" key={item.name} onClick={() => onOpenCharacter(index)}>
                        <img src={mobileImage(item.card)} className="picture" alt=""/>
                        <div className="info">
                            <div className="box">
                                <img src={mobileImage(item.nameEn)} className="nameEn" alt=""/>
                                <img src={mobileImage(item.name)} className="nameC" alt="角色名称"/>
                                <span className="desc">{item.description}</span>
                            </div>
                            <img src={mobileImage("homes_10.png")} className="right" alt="查看详情"/>
                        </div>
                    </button>
                );
            })}
        </div>
    );
});

export default CharacterListScreen;
